<template>
  <app-data-editor
    :id="id"
    title="Редактирование Валюты"
    resource="currencies"
    :elements="elements"
    add-message="Валюта добавлена"
    edit-message="Валюта изменена"
    @change="(payload) => isChanged = payload"
  />
</template>

<script>
import mixin from "./../../mixins/confirm-cancel-changes.js";
export default {
  mixins: [mixin],
  props: ["id"],
  data() {
    return {
      elements: [
        [
          {
            title: "Наименование",
            name: "title",
            control: {
              type: "title-text",
              required: true,
              rules: [
                v => !!v || "Наименование обязательно к заполнению",
                v =>
                  v.length >= 2 ||
                  "Наименование должно содержать не менее 2-х символов",
              ],
            },
            default: "",
          },
        ],
      ],
    };
  },
};
</script>
